"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textCSS = exports.responsiveTextCSS = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _responsive = require("../responsive");
var _utils = require("../utils");
var _constants = require("./constants");
var _excluded = ["font", "fontSize", "lineHeight"],
  _excluded2 = ["font", "fontSize", "lineHeight"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var getLineHeight = function getLineHeight(_ref) {
  var lineHeightSelector = _ref.lineHeightSelector,
    lineHeightProp = _ref.lineHeight,
    font = _ref.font,
    fontSize = _ref.fontSize,
    bp = _ref.breakpoint;
  var overriddenLineHeight = lineHeightProp;
  var breakpoint = bp;
  var lineHeight =
  // Select the line height from the theme using the prop value
  lineHeightSelector(overriddenLineHeight, {
    font: font,
    breakpoint: breakpoint
  }) ||
  // If it's not a theme size, use the value directly
  lineHeightProp ||
  // If no value was given, use the line height for the selected font size
  lineHeightSelector(fontSize, {
    font: font,
    breakpoint: breakpoint
  });
  return lineHeight;
}; // This has to be done outside the Text component because it is reused by Link.

var baseCSS = function baseCSS(_ref2) {
  var theme = _ref2.theme,
    color = _ref2.color,
    backgroundColor = _ref2.backgroundColor,
    display = _ref2.display,
    _ref2$font = _ref2.font,
    font = _ref2$font === void 0 ? _constants.defaultProps.font : _ref2$font,
    fontWeight = _ref2.fontWeight,
    fontStyle = _ref2.fontStyle,
    _ref2$hyphens = _ref2.hyphens,
    hyphens = _ref2$hyphens === void 0 ? _constants.defaultProps.hyphens : _ref2$hyphens,
    margin = _ref2.margin,
    textAlign = _ref2.textAlign,
    textDecoration = _ref2.textDecoration,
    wordBreak = _ref2.wordBreak;
  return _objectSpread(_objectSpread({
    color: (0, _utils.cssProp)(theme.selectors.color, color),
    display: display,
    backgroundColor: (0, _utils.cssProp)(theme.selectors.color, backgroundColor),
    // The font prop only accepts names from the theme so the selector
    // will always return a value, so it's safe to cast to string
    fontFamily: theme.selectors.fontFamily(font),
    fontWeight: (0, _utils.cssProp)(theme.selectors.fontWeight, fontWeight),
    hyphens: hyphens
  }, (0, _utils.cssValuesProp)(theme.selectors.space, margin, 'margin')), {}, {
    textAlign: textAlign,
    textDecoration: textDecoration,
    wordBreak: wordBreak,
    fontStyle: fontStyle,
    em: {
      fontStyle: 'italic'
    },
    strong: {
      fontWeight: theme.selectors.fontWeight('bold')
    }
  });
};
var textCSS = function textCSS(_ref3) {
  var _ref3$font = _ref3.font,
    font = _ref3$font === void 0 ? _constants.defaultProps.font : _ref3$font,
    fontSizeProp = _ref3.fontSize,
    lineHeightProp = _ref3.lineHeight,
    props = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  var fontSizeProps = {};
  if (!!fontSizeProp) {
    var fontSize = fontSizeProp;
    fontSizeProps = {
      fontSize: (0, _utils.px)((0, _utils.cssProp)(props.theme.selectors.fontSize, fontSize)),
      lineHeight: getLineHeight({
        lineHeightSelector: props.theme.selectors.lineHeight,
        font: font,
        lineHeight: lineHeightProp,
        fontSize: fontSize
      })
    };
  }
  return _objectSpread(_objectSpread({}, baseCSS(_objectSpread({
    font: font
  }, props))), fontSizeProps);
};
exports.textCSS = textCSS;
var responsiveTextCSS = function responsiveTextCSS(_ref4) {
  var _ref4$font = _ref4.font,
    font = _ref4$font === void 0 ? _constants.defaultProps.font : _ref4$font,
    fontSizeProp = _ref4.fontSize,
    lineHeightProp = _ref4.lineHeight,
    props = (0, _objectWithoutProperties2.default)(_ref4, _excluded2);
  var breakpoints = props.theme.values.breakpoint;
  var fontSize = fontSizeProp;
  var mediaQueries = Object.keys(breakpoints).reduce(function (queries, bp) {
    var mediaQueryKey = (0, _responsive.buildMediaQuery)(breakpoints[bp], true);
    var breakpoint = bp;
    return _objectSpread(_objectSpread({}, queries), {}, (0, _defineProperty2.default)({}, mediaQueryKey, {
      fontSize: (0, _utils.px)(props.theme.selectors.fontSize(fontSize, {
        font: font,
        breakpoint: breakpoint
      }) || fontSize),
      lineHeight: getLineHeight({
        lineHeightSelector: props.theme.selectors.lineHeight,
        font: font,
        lineHeight: lineHeightProp,
        fontSize: fontSize,
        breakpoint: breakpoint
      })
    }));
  }, {});
  return _objectSpread(_objectSpread({}, baseCSS(_objectSpread({
    font: font
  }, props))), mediaQueries);
};
exports.responsiveTextCSS = responsiveTextCSS;